import React from 'react';
import {
	defineMessages,
	useIntl,
} from 'react-intl';

import DonutPagesChart from '../components/DonutPagesChart';



const messages = defineMessages({
	crossdomain: {
		id: 'ui.contentOverview.tableFilter.canonicalTypes.external',
	},
	internal_other: {
		id: 'ui.contentOverview.canonicalTypes.internal.otherPage',
	},
	internal_self: {
		id: 'ui.contentOverview.canonicalTypes.internal.self',
	},
	invalid: {
		id: 'ui.contentOverview.tableFilter.canonicalTypes.invalid',
	},
	none: {
		id: 'ui.contentOverview.tableFilter.canonicalTypes.none',
	},
	not_applicable: {
		id: 'ui.contentOverview.tableFilter.canonicalTypes.notApplicable',
	},
});



type Props = {
	data: Array<{
		count: number;
		percentage: number;
		value: string;
	}>;
};

const CanonicalTypeChart: React.FC<Props> = (props) => {
	const {
		data,
	} = props;

	const intl = useIntl();

	const categories = [
		{
			value: 'internal_self',
			label: intl.formatMessage(messages.internal_self),
			color: '#42CC67',
		},
		{
			value: 'internal_other',
			label: intl.formatMessage(messages.internal_other),
			color: 'rgba(66,204,103,0.8)',
		},
		{
			value: 'crossdomain',
			label: intl.formatMessage(messages.crossdomain),
			color: '#FE8719',
		},
		{
			value: 'invalid',
			label: intl.formatMessage(messages.invalid),
			color: 'rgba(254,135,25,0.8)',
		},
		{
			value: 'none',
			label: intl.formatMessage(messages.none),
			color: '#FF5959',
		},
		{
			value: 'not_applicable',
			label: intl.formatMessage(messages.not_applicable),
			color: '#8595A6',
		},
	];

	return (
		<DonutPagesChart
			categories={categories}
			data={data}
			name="canonical_type"
			percentageFactor={100}
		/>
	);
};



export default React.memo(CanonicalTypeChart);
